import { DownOutlined } from '@ant-design/icons';
import { Button, Flex } from '@revenuemarket/cds';
import { Colors } from '@revenuemarket/design';
import { Typography } from 'antd';

import { CategoryTreeItem } from '~apis/categories';
import { FlattenTreeResult } from '~components/ui/HorizontalTreeTable/Table';
import { css } from '~libs/emotion';

import CategoryTreeSelect from './CategoryTreeSelect';

interface Props {
  treeList: FlattenTreeResult<CategoryTreeItem>[];
  onSelect: (categoryLabelKey: string) => void;
  targetCategory?: FlattenTreeResult<CategoryTreeItem>;
  autoClose?: boolean;
}

const CategorySimpleLabelSelctor: React.FC<Props> = ({
  autoClose,
  treeList,
  onSelect,
  targetCategory,
}) => {
  return (
    <CategoryTreeSelect
      autoClose={autoClose}
      treeList={treeList}
      onSelect={(categoryLabelKey) => {
        onSelect(categoryLabelKey);
      }}
      footerElement={<div />}
      closeOnSelect
      defaultActiveKey={targetCategory?.key ? [targetCategory.key] : []}
      triggerElement={
        <Button
          border
          style={{
            width: '100%',
            height: 28,
            display: 'flex',
            alignItems: 'center',
          }}
          className={css`
            & > div {
              display: flex !important;
              width: inherit !important;
              justify-content: space-between !important;
            }
          `}
        >
          {targetCategory ? (
            <Typography.Text
              style={{
                color: Colors.gray900,
              }}
            >
              {targetCategory.value?.name}
            </Typography.Text>
          ) : (
            <Flex
              justify="space-between"
              align="center"
              style={{
                width: '100%',
              }}
            >
              <Typography.Text
                style={{
                  color: Colors.gray400,
                }}
              >
                계정 분류 선택
              </Typography.Text>
            </Flex>
          )}
          <DownOutlined
            style={{
              color: Colors.gray400,
            }}
          />
        </Button>
      }
    />
  );
};

export default CategorySimpleLabelSelctor;
